import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Popup,
  Form
} from 'semantic-ui-react'

const BaseCheckboxField = ({
  name,
  width,
  checked,
  onChange,
  popupTxt,
  labelTxt
}) => (
  <Form.Field width={R.isNil(width) ? null : width}>
    <Popup
      trigger={<label>{labelTxt}</label>}
      content={popupTxt}
    />
    <Form.Checkbox name={name} checked={checked} onChange={onChange} />
  </Form.Field>
)

BaseCheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  popupTxt: PropTypes.string.isRequired,
  labelTxt: PropTypes.string.isRequired
}

export default BaseCheckboxField



// WEBPACK FOOTER //
// ./webAdmin/forms/baseCheckbox.js